module.exports = __webpack_public_path__ + "img/icon-dapp-rsk-collective.3de591b6.svg";